import type { HttpMethod } from '@core/entities/ApiRequest';

const METHOD_COLORS: Record<HttpMethod, string> = {
  GET: 'text-emerald-500',
  POST: 'text-amber-500',
  PUT: 'text-blue-500',
  PATCH: 'text-purple-500',
  DELETE: 'text-red-500',
  OPTIONS: 'text-gray-400',
  HEAD: 'text-gray-400',
  TRACE: 'text-gray-400',
  CONNECT: 'text-gray-400',
};

interface MethodBadgeProps {
  method: HttpMethod;
  className?: string;
}

export const MethodBadge = ({ method, className = '' }: MethodBadgeProps) => (
  <span className={`text-[10px] font-bold tracking-tight ${METHOD_COLORS[method]} ${className}`}>
    {method}
  </span>
);
